// ui/MediaGallery.jsx
"use client";

import { useState, lazy } from "react";
import Image from "next/image";

const VideoModal = lazy(() => import("@/components/videoModel"));

const MediaGallery = ({ items, className = "" }) => {
    const [modal, setModal] = useState({ open: false, url: "" });

    if (!items || items.length === 0) return null;

    const leftItems = items.slice(0, 4);
    const main = items[4] || items[0];

    const handlePlay = () => {
        if (!main.isVideo || !main.videoUrl) return;
        setModal({ open: true, url: main.videoUrl });
    };

    return (
        <section className={`w-full text-white ${className}`}>
            <VideoModal
                open={modal.open}
                url={modal.url}
                onClose={() => setModal({ open: false, url: "" })}
            />

            <div className="grid grid-cols-1 lg:grid-cols-[1.6fr_2.1fr] gap-6">
                <div className="grid grid-cols-2 grid-rows-2 gap-4">
                    {leftItems.map((img, i) => (
                        <div
                            key={i}
                            className="relative h-[160px] md:h-[210px] lg:h-[230px] overflow-hidden"
                        >
                            <Image
                                src={img.src}
                                alt={img.alt}
                                width={500}
                                height={350}
                                className="w-full h-full object-cover"
                            />

                            <div className="absolute bottom-0 h-16 w-full bg-gradient-to-b from-transparent to-[#081E2D]" />

                            {(img.heading || img.subheading) && (
                                <div className="absolute left-4 right-4 bottom-2 z-10">
                                    {img.heading && (
                                        <p className="text-sm md:text-base font-semibold text-white">
                                            {img.heading}
                                        </p>
                                    )}

                                    {img.subheading && (
                                        <p className="text-[11px] md:text-xs text-white/80">
                                            {img.subheading}
                                        </p>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="relative h-[220px] md:h-[320px] lg:h-[468px] overflow-hidden">
                    <Image
                        src={main.src}
                        alt={main.alt}
                        width={900}
                        height={600}
                        className="w-full h-full object-cover"
                        priority
                    />

                    {main.isVideo && main.videoUrl && (
                        <button
                            type="button"
                            onClick={handlePlay}
                            className="absolute inset-0 flex items-center justify-center cursor-pointer"
                        >
                            <span className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-white/85 flex items-center justify-center text-[#001C2E] text-2xl shadow-lg">
                                ▶
                            </span>
                        </button>
                    )}

                    <div className="absolute bottom-0 h-20 w-full bg-gradient-to-b from-transparent to-[#081E2D]" />

                    {(main.heading || main.subheading) && (
                        <div className="absolute left-4 right-4 bottom-2 space-y-1">
                            {main.heading && (
                                <p className="text-sm md:text-base font-semibold text-white">
                                    {main.heading}
                                </p>
                            )}
                            {main.subheading && (
                                <p className="text-[11px] md:text-xs text-white/80 max-w-xl">
                                    {main.subheading}
                                </p>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default MediaGallery;
